
/**
 *      Insight search page.
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 08/10/2017
 *      Modified on 07/13/2020
 */


/**
 * Call Query Manager Web endpoint to get the HTML of the search page to render.
 */
function getSearchUI( time ) {

    // Call the Query Manager Web endpoints to get partial Search page HTML to render
    // Render search page in parts: group search, current filters, available filters, search results, recent searches, trending searches
    //get alias if alias parameter is passed in the URL
    setAliasFromURL();

    // Set global query if query parameter is passed in the URL
    setQueryFromURL();

    // Set type if type is passed in the URL
    setTypeFromURL();

    // Set filters if filters is passed in the URL
    setFiltersFromURL();

    // Set page if page is passed in the URL
    setPageFromURL();

    // Set global page size if size parameter is passed in the URL
    setPageSizeFromURL();

    // Set global group filter
    setGroupFromURL();

    // Set view type of search results if passed in the URL
    setViewTypeFromURL();

    // Get group search menu
    displayGroupMenu( 1 );

    if ( App && App.globalState ) {

        var query = App.globalState.query;

        // Check if query is defined

        if ( query ) {

            // Get current filters

            displayFiltersMenu( 1 );

            // Get available filters

            displayAggregationsMenu( 1 );

            // Get search results

            displayResultsMenu( 1 );

            // Get image results

            if ( App.globalState.alias === "eva" || App.globalState.alias === "edi" ) {
                if ( query !== "all" && query !== "any") {
                    displayImagesMenu( 1 );
                }
            }
        }

        // Get recent searches
        displayHistoryMenu( 1 );

        // Get trending searches
        displayTrendsMenu( 1 );

        // Attach listener to show full width filters on small screens
        $('#search-layout .search-page #filters-show-wrapper #show-filters-menu').on('click', function(e) {
            e.preventDefault();

            // Hide the button to show filters
            var show_menu = document.getElementById('show-filters-menu');
            if ( show_menu && show_menu.style ) {
                show_menu.style.display = 'none';
            }

            // Show the button to hide filters
            var hide_menu = document.getElementById('hide-filters-menu');
            if ( hide_menu && hide_menu.style ) {
                hide_menu.style.display = 'block';
            }

            // Show filters menu
            var parent_element =  document.getElementById('filters-parent-wrapper');
            if ( parent_element && parent_element.style ) {
                parent_element.style.display = 'block';

                // Scroll search filters into view
              //  parent_element.scrollIntoView();
            }

        });

        // Attach listener to hide full width filters on small screens
        $('#search-layout .search-page #hide-filters-menu').on('click', function(e) {

            e.preventDefault();

            // Show the button to show filters
            var show_menu = document.getElementById('show-filters-menu');
            if ( show_menu && show_menu.style ) {
                show_menu.style.display = 'initial';
            }

            // Hide the button to hide history
            var hide_menu = document.getElementById('hide-filters-menu');
            if ( hide_menu && hide_menu.style ) {
                hide_menu.style.display = 'none';
            }

            // Hide filters menu
            var parent_element =  document.getElementById('filters-parent-wrapper');
            if ( parent_element && parent_element.style ) {
                parent_element.style.removeProperty('display');
            }

            // Scroll search results into view
            var search_results =  document.getElementById('results-content' );
            if ( search_results ) {
                search_results.scrollIntoView();
            }
        });

        // Attach listener to show full width history and trends on small screens
        $('#search-layout .search-page #history-show-wrapper #show-history-menu').on('click', function(e) {
            e.preventDefault();

            // Hide the button to show history
            var show_menu = document.getElementById('show-history-menu');
            if ( show_menu && show_menu.style ) {
                show_menu.style.display = 'none';
            }

            // Show the button to hide history
            var hide_menu = document.getElementById('hide-history-menu');
            if ( hide_menu && hide_menu.style ) {
                hide_menu.style.display = 'block';
            }

            // Show history menu
            var parent_element =  document.getElementById('history-parent-wrapper');
            if ( parent_element && parent_element.style ) {
                parent_element.style.display = 'block';

                // Scroll search history into view
                //parent_element.scrollIntoView({ block: "end" });
            }
        });

        // Attach listener to hide full width history and trends on small screens
        $('#search-layout .search-page #history-show-wrapper #hide-history-menu').on('click', function(e) {
            e.preventDefault();

            // Show the button to show history
            var show_menu = document.getElementById('show-history-menu');
            if ( show_menu && show_menu.style ) {
                show_menu.style.display = 'block';
            }

            // Hide the button to hide history
            var hide_menu = document.getElementById('hide-history-menu');
            if ( hide_menu && hide_menu.style ) {
                hide_menu.style.display = 'none';
            }

            // Hide history menu
            var parent_element =  document.getElementById('history-parent-wrapper');
            if ( parent_element && parent_element.style ) {
                parent_element.style.removeProperty('display' );
            }

            // Scroll search results into view
            var search_results =  document.getElementById('results-content' );
            if ( search_results ) {
                search_results.scrollIntoView();
            }

        });

    }
}

/**
 * Display group menu generated by Query Manager Web.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayGroupMenu( tryNumber ) {

    var groupurl = getGroupURL();

    if ( groupurl ) {

        var groupid = 'group-content';
        var groupiconid = 'group-loading-icon';

        // Display loading image
        var imageurl = "/static/images/skeleton-search-groups.png";

        loadSkeletonImage( groupid, groupiconid, imageurl );
       // console.log("Get group menu");
        var d1 = new Date();
       // console.log(d1.getTime());

        $.ajax({
            url: groupurl,
            data: {},
            dataType: 'html'
        })
        .done( function( data ) {

            console.log("Got group menu");
            var d2 = new Date();
            var ms = d2.getTime() - d1.getTime();
            console.log("Took " + ms + " ms");


            // Display group menu
            renderPageRegion( data, groupid );

            // Hide loading icon
            hideLoadingIcon( groupiconid );

            // Set search option if it is defined
            if ( App.globalState.searchOption ) {
                setSearchOption();
            }
            // Set search group if it is defined
            if ( App.globalState.group ) {
                setSearchGroup();
            }
            // Listen for option select of datatype-based groups
            $('#group-region .content-tabs .group-item').on('click', function(e) {
                e.preventDefault();
                var target = e.currentTarget;
                showSearchGroup( target );
            });

            // Listen for site option select
            $('#group-region .sites select').on('change', function(e) {
                e.preventDefault();
                var target = e.currentTarget;
                selectSiteOption( target );
            });

            // Listen for search option select (fuzzy, exact, etc.)
            $('#group-region .search-options select').on('change', function(e) {
                e.preventDefault();
                var target = e.currentTarget;
                selectSearchOption( target );
            });

            // Listen for Advanced Search click
            $('#group-region #advanced-search').on('click', function(e) {

                var url = "/advanced-search/";
                var alias = App.globalState.alias;
                var query = App.globalState.query;
                var type = App.globalState.searchType;
                var filters = App.globalState.searchFilters;
                var pagesize = App.globalState.pageSize;
                var grid = App.globalState.grid;

                e.preventDefault();

                if ( alias ) {
                    url += alias + "/";
                }
                if ( query || type || filters || grid || ( pagesize && pagesize.toString() !== "20" ) ) {
                    url += '?';
                }

                if ( query ) {
                    url += 'q=' + query;
                }

                if ( type && query ) {
                    url += '&type=' + type;
                } else if ( type ) {
                    url += 'type=' + type;
                }

                if ( filters && ( query || type ) ) {
                    url += '&filters=' + filters;
                } else if ( filters ) {
                    url += 'filters=' + filters;
                }

                // Default pagesize is 20 and does not need a URL parameter
                if ( pagesize ) {
                    if ( query || type || filters ) {
                        url += '&pagesize=' + pagesize;
                    } else {
                        url += 'pagesize=' + pagesize;
                    }
                }

                // Search results view
                if ( grid ) {
                    if ( ( pagesize && pagesize.toString() !== "20" ) || query || type || filters ) {
                        url += '&view=grid';
                    } else {
                        url += 'view=grid';
                    }
                }

                router.navigate( url, { trigger: true } );
            });
        } )
        .fail( function( jqXHR, textStatus, errorThrown ) {
            console.log( "Error: Query Manager Web failure, try " + tryNumber );
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
            hideLoadingIcon( groupiconid );

            if ( tryNumber <= 5 ) {
                retry( displayGroupMenu( tryNumber + 1 ), tryNumber + 1, 5 );
            } else {
                console.log("Tried calling Query Manager Web to display group menu 5 times.");
            }
        } );
    }
}

/**
 * Display current search filters generated by Query Manager Web.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayFiltersMenu( tryNumber ) {

    var filtersurl = getFiltersURL();

    if ( filtersurl ) {

        var filtersid = 'filters-content';
        var filtersiconid = 'filters-loading-icon';

        // Show loading image
        var imageurl = "/static/images/skeleton-search-filters.png";
        loadSkeletonImage( filtersid, filtersiconid, imageurl );

      //  console.log("Get filters menu");
        var d1 = new Date();
     //   console.log(d1.getTime());

        $.ajax({
            url: filtersurl,
            data: {},
            dataType: 'html'
        })
        .done( function( data ) {

            console.log("Got filters menu");
            var d2 = new Date();
            var ms = d2.getTime() - d1.getTime();
            console.log("Took " + ms + " ms");

            // Display group menu
            renderPageRegion( data, filtersid );
            // Hide loading icon
            hideLoadingIcon( filtersiconid );

            // Listen for remove type filter click
            $('.remove-type-filter').on('click', function(e) {
                e.preventDefault();
                clearSearchTypes();
            });

            // Listen for remove multi type filter click
            $('.remove-multi-type-filter').on('click', function(e) {
                e.preventDefault();
                var target = e.currentTarget;
                removeSearchType( target );
            });

            // Listen for remove facet click
            $('.remove-facet-filter').on('click', function(e) {
                e.preventDefault();
                var target = e.currentTarget;
                removeTypeFacet( target );
            });

        } )
        .fail( function( jqXHR, textStatus, errorThrown ) {
            console.log( "Error: Query Manager Web failure, try " + tryNumber );
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
            hideLoadingIcon( filtersiconid );

            if ( tryNumber <= 5 ) {
                retry( displayFiltersMenu( tryNumber + 1 ), tryNumber + 1, 5 );
            } else {
                console.log("Tried calling Query Manager Web to display filters menu 5 times.");
            }
        } );
    }
}

/**
 * Display aggregations menu generated by Query Manager Web.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayAggregationsMenu( tryNumber ) {

    var aggregationsurl = getAggregationsURL();

    console.log('aggregationsurl: ', aggregationsurl );         // testing ======

    if ( aggregationsurl ) {

        var aggregationsid = 'aggregations-content';
        var aggregationsiconid = 'aggregations-loading-icon';
        var url = "/static/images/skeleton-aggregations.png";
        loadSkeletonImage( aggregationsid, aggregationsiconid, url );

     //   console.log("Get aggregations menu");
        var d1 = new Date();
     //   console.log(d1.getTime());

        $.ajax({
            url: aggregationsurl,
            data: {},
            dataType: 'html'
        })
        .done( function( data ) {

            console.log("Got aggregations menu");
            var d2 = new Date();
            var ms = d2.getTime() - d1.getTime();
            console.log("Took " + ms + " ms");

            // Display aggregations menu
            renderPageRegion( data, aggregationsid );

            // Hide loading icon
            hideLoadingIcon( aggregationsiconid );

            // Listen for Refine search filters button click
            $('#refine-search-filters').on('click', function(e) {
                e.preventDefault();
                refineSearchFilters();
            });

            // Listen for Clear search filters button click
            $('#clear-search-filters').on('click', function(e) {
                e.preventDefault();
                clearSearchFilters();
            });

            // Listen for type facet name click
            $('.display-facet').on('click', function(e) {
                e.preventDefault();
                var target = e.currentTarget;

                selectTypeFacet( target );
            });
        } )
        .fail( function( jqXHR, textStatus, errorThrown ) {
            console.log( "Error: Query Manager Web failure, try " + tryNumber );
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
            hideLoadingIcon( aggregationsiconid );

            if ( tryNumber <= 5 ) {
                retry( displayAggregationsMenu( tryNumber + 1 ), tryNumber + 1, 5 );
            } else {
                console.log("Tried calling Query Manager Web to display aggregations menu 5 times.");
            }
        } );
    }

}

/**
 * Display search results generated by Query Manager Web.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayResultsMenu( tryNumber ) {

    var resultssurl = getSearchResultsURL();

    if ( resultssurl ) {

        var resultsid = 'results-content';
        var resultsiconid = 'results-icon-id';

        // Show loading image
        var imageurl = "/static/images/skeleton-search-results.png";
        loadSkeletonImage( resultsid, resultsiconid, imageurl );

        //console.log("Get results menu");
        var d1 = new Date();
       // console.log(d1.getTime());

        $.ajax({
            url: resultssurl,
            data: {},
            dataType: 'html'
        })
        .done( function( data ) {

            console.log("Got results menu");
            var d2 = new Date();
            var ms = d2.getTime() - d1.getTime();
            console.log("Took " + ms + " ms");

            // Display search results
            renderPageRegion( data, resultsid );
            // Hide loading icon
            hideLoadingIcon( resultsiconid );

            // Style search results

            // Set search results per page if it is defined
            if ( App.globalState.pageSize ) {
                setResultsPerPage();
            }

            // Listen for results per page select
            $('#results-region .search-results-pagination select').on('change', function(e) {
                e.preventDefault();
                var target = e.currentTarget;
                showResultsPerPage( target );
            });

            // Listen for record viewer link click
            $( '#results-region .viewer-link' ).on('click', function(e) {
                viewerLinkListener( e );
            });

            // Listen for pagination click
            $('#results-region .search-pagination .search-page-number').on('click', function(e) {
                e.preventDefault();
                var target = e.currentTarget;
                showSearchPage( target );
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            });
            // Listen for grid view click
            $('#results-region .search-results #grid-search-view').on('click', function(e) {
                e.preventDefault();
                App.globalState.grid = true;
                // Update URL
                setSearchResultsView( );
                reloadResults();
            });

            // Listen for list view click
            $('#results-region .search-results #list-search-view').on('click', function(e) {
                e.preventDefault();
                App.globalState.grid = false;
                // Update URL
                setSearchResultsView( );
                reloadResults();
            });

        })
        .fail( function( jqXHR, textStatus, errorThrown ) {
            console.log( "Error: Query Manager Web failure, try " + tryNumber );
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
            hideLoadingIcon( resultsiconid );

            if ( tryNumber <= 5 ) {
                retry( displayResultsMenu( tryNumber + 1 ), tryNumber + 1, 5 );
            } else {
                console.log("Tried calling Query Manager Web to display results menu 5 times.");
            }
        });
    }

}

/**
 * Display search images generated by Query Manager Web.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayImagesMenu( tryNumber ) {

    var imagessurl = getSearchImagesURL();

    if ( imagessurl ) {

        var imagesid = 'images-content';
        var imagesiconid = 'images-icon-id';

        showLoadingIcon( imagesid, imagesiconid, 'Loading images...' );

        $.ajax({
            url: imagessurl,
            data: {},
            dataType: 'html'
        })
        .done( function( data ) {

            // Display search results
            renderPageRegion( data, imagesid );
            // Hide loading icon
            hideLoadingIcon( imagesiconid );


        })
        .fail( function( jqXHR, textStatus, errorThrown ) {
            console.log( "Error: Query Manager Web failure, try " + tryNumber );
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
            hideLoadingIcon( imagesiconid );

            if ( tryNumber <= 5 ) {
                retry( displayImagesMenu( tryNumber + 1 ), tryNumber + 1, 5 );
            } else {
                console.log("Tried calling Query Manager Web to display images menu 5 times.");
            }
        });
    }
}

/**
 * Display search history generated by the Query Manager Web.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayHistoryMenu( tryNumber ) {

    var historyurl = getSearchHistoryURL();

    if ( historyurl ) {

        var historyid = 'history-content';
        var historyiconid = 'history-icon-id';
        var url = "/static/images/skeleton-history-trends.png";
        loadSkeletonImage( historyid, historyiconid, url );

        var d1 = new Date();

        $.ajax({
            url: historyurl,
            data: {},
            dataType: 'html'
        })
        .done( function( data ) {

            console.log("Got search history menu");
            var d2 = new Date();
            var ms = d2.getTime() - d1.getTime();
            console.log("Took " + ms + " ms");


            // Display search results
            renderPageRegion( data, historyid );
            // Hide loading icon
            hideLoadingIcon( historyiconid );
        })
        .fail( function( jqXHR, textStatus, errorThrown ) {
            console.log( "Error: Query Manager Web failure, try " + tryNumber );
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
            hideLoadingIcon( historyiconid );

            if ( tryNumber <= 5 ) {
                retry( displayHistoryMenu( tryNumber + 1 ), tryNumber + 1, 5 );
            } else {
                console.log("Tried calling Query Manager Web to display history menu 5 times.");
            }
        });
    }
}

/**
 * Display trending searches for all uesrs generated by the Query Manager Web.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayTrendsMenu( tryNumber ) {

    var url = getSearchTrendsURL();

    if ( url ) {

        var contentid = 'trends-content';
        var iconid = 'trends-icon-id';
        var imageurl = "/static/images/skeleton-history-trends.png";

        loadSkeletonImage( contentid, iconid, imageurl );

        var d1 = new Date();

        $.ajax({
            url: url,
            data: {},
            dataType: 'html'
        })
        .done( function( data ) {

            console.log("Got search trends menu");
            var d2 = new Date();
            var ms = d2.getTime() - d1.getTime();
            console.log("Took " + ms + " ms");

            // Display search results
            renderPageRegion( data, contentid );
            // Hide loading icon
            hideLoadingIcon( iconid );
        })
        .fail( function( jqXHR, textStatus, errorThrown ) {
            console.log( "Error: Query Manager Web failure, try " + tryNumber );
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
            hideLoadingIcon( iconid );

            if ( tryNumber <= 5 ) {
                retry( displayTrendsMenu( tryNumber + 1 ), tryNumber + 1, 5 );
            } else {
                console.log("Tried calling Query Manager Web to display trends menu 5 times.");
            }
        });
    }
}

/**
 * Construct view URL for Query Manager Web group menu.
 * @returns {*}
 */
function getGroupURL() {

    var alias =  App.globalState.alias;
    var group = App.globalState.group;

    if ( alias ) {

        var viewurl = '/query/web/api/v1/group/' + alias;

        // Default search group is "all" and does not need a URL parameter
        if ( group && group !== "allgroup" ) {
            viewurl += '?group=' + group;
        }
    }

    return viewurl;
}

/**
 * Construct view URL for Query Manager Web current filters menu.
 * @returns {*}
 */
function getFiltersURL() {

    var viewurl;

    var alias =  App.globalState.alias;
    var query = App.globalState.query;
    var type = App.globalState.searchType;
    var filters = App.globalState.searchFilters;

    if ( alias ) {

        viewurl = '/query/web/api/v1/searchfilters/' + alias;

        if ( query || type || filters ) {
            viewurl += '?';
        }

        // Query
        if ( query ) {
            viewurl += 'query=' + query;
        }

        // Search type
        if ( type && query ) {
            viewurl += '&type=' + type;
        } else if ( type ) {
            viewurl += 'type=' + type;
        }

        // Search filters
        if ( filters && ( query || type )) {
            viewurl += '&filters=' + filters;
        } else if ( filters ) {
            viewurl += 'filters=' + filters;
        }
    }

    return viewurl;
}

/**
 * Construct view URL for Query Manager Web aggregations menu.
 * @returns {*}
 */
function getAggregationsURL() {

    var viewurl;

    var alias =  App.globalState.alias;
    var query = App.globalState.query;
    var type = App.globalState.searchType;
    var filters = App.globalState.searchFilters;
    var page = App.globalState.searchPage;
    var searchoption = App.globalState.searchOption;
    var fuzzydegree = App.globalState.fuzzyDegree;
    var pagesize = App.globalState.pageSize;
    var group = App.globalState.group;

    if ( alias ) {

        viewurl = '/query/web/api/v1/searchaggregations/' + alias;

        if ( query || type || filters || page || searchoption ) {
            viewurl += '?';
        }

        // Query
        if ( query ) {
            viewurl += 'query=' + query;
        }
        // Current page
        if ( page && query ) {
            viewurl += '&page=' + page;
        } else if ( page ) {
            viewurl += 'page=' + page;
        }

        // Search type
        if ( type && ( query || page ) ) {
            viewurl += '&type=' + type;
        } else if ( type ) {
            viewurl += 'type=' + type;
        }

        // Search filters
        if ( filters && ( query || page || type )) {
            viewurl += '&filters=' + filters;
        } else if ( filters ) {
            viewurl += 'filters=' + filters;
        }

        // Search option
        if ( searchoption && ( query || page || type || filters )) {
            viewurl += '&searchtype=' + searchoption;
        } else if ( searchoption ) {
            viewurl += 'searchtype=' + searchoption;
        }
        if ( fuzzydegree && searchoption && ( query || page || type || filters )) {
            viewurl += '&fuzziness=' + fuzzydegree;
        }

        // Results per page

        // Default pagesize is 20 and does not need a URL parameter
        if ( pagesize ) {
            if ( query || page || type || filters || searchoption ) {
                viewurl += '&pagesize=' + pagesize;
            } else {
                viewurl += 'pagesize=' + pagesize;
            }
        }

        // Search group

        // Default search group is "all" and does not need a URL parameter
        if ( group && group !== "allgroup" ) {
            if ( ( page && pagesize.toString() !== "20" ) || query || page || type || filters || searchoption ) {
                viewurl += '&group=' + group;
            } else {
                viewurl += 'group=' + group;
            }
        }
    }

    return viewurl;
}

/**
 * Construct view URL for Query Manager Web search results.
 * @returns {*}
 */
function getSearchResultsURL() {

    var viewurl;

    var alias =  App.globalState.alias;
    var query = App.globalState.query;
    var type = App.globalState.searchType;
    var filters = App.globalState.searchFilters;
    var page = App.globalState.searchPage;
    var searchoption = App.globalState.searchOption;
    var fuzzydegree = App.globalState.fuzzyDegree;
    var pagesize = App.globalState.pageSize;
    var group = App.globalState.group;
    var grid = App.globalState.grid;

    if ( alias ) {

        viewurl = '/query/web/api/v1/searchresults/' + alias;

        if ( query || type || filters || page || searchoption || group || grid ) {
            viewurl += '?';
        }

        // Query
        if ( query ) {
            viewurl += 'query=' + query;
        }
        // Current page
        if ( page && query ) {
            viewurl += '&page=' + page;
        } else if ( page ) {
            viewurl += 'page=' + page;
        }

        // Search type
        if ( type && ( query || page ) ) {
            viewurl += '&type=' + type;
        } else if ( type ) {
            viewurl += 'type=' + type;
        }

        // Search filters
        if ( filters && ( query || page || type )) {
            viewurl += '&filters=' + filters;
        } else if ( filters ) {
            viewurl += 'filters=' + filters;
        }

        // Search option
        if ( searchoption && ( query || page || type || filters )) {
            viewurl += '&searchtype=' + searchoption;
        } else if ( searchoption ) {
            viewurl += 'searchtype=' + searchoption;
        }
        if ( fuzzydegree && searchoption && ( query || page || type || filters )) {
            viewurl += '&fuzziness=' + fuzzydegree;
        }

        // Results per page

        // Default pagesize is 20 and does not need a URL parameter
        if ( pagesize ) {
            if ( query || page || type || filters || searchoption ) {
                viewurl += '&pagesize=' + pagesize;
            } else {
                viewurl += 'pagesize=' + pagesize;
            }
        }

        // Search group

        // Default search group is "all" and does not need a URL parameter
        if ( group && group !== "allgroup" ) {
            if ( ( page && pagesize.toString() !== "20" ) || query || page || type || filters || searchoption ) {
                viewurl += '&group=' + group;
            } else {
                viewurl += 'group=' + group;
            }
        }

        // Search grid layout flag
        if ( grid && grid.toString() === "true" ) {
            viewurl += '&grid=' + grid;
        }
    }

    return viewurl;
}

/**
 * Construct view URL for Query Manager Web images results.
 */
function getSearchImagesURL() {
    var viewurl;

    var alias =  App.globalState.alias;
    var query = App.globalState.query;

    if ( alias ) {

        viewurl = '/query/web/api/v1/searchimages/' + alias;

        // Query
        if ( query ) {
            viewurl += '?query=' + query;
        }

    }

    return viewurl;
}

/**
 * Construct view URL for Query Manager Web recent searches history.
 */
function getSearchHistoryURL() {

    var viewurl;

    var alias =  App.globalState.alias;
    var query = App.globalState.query;

    if ( alias ) {

        viewurl = '/query/web/api/v1/searchhistory/' + alias + '/';

        // Query
        if ( query ) {
            viewurl += '?query=' + query;
        }
    }

    return viewurl;

}

/**
 * Construct view URL for Query Manager Web trending searches.
 */
function getSearchTrendsURL() {

    var viewurl;

    var alias =  App.globalState.alias;

    if ( alias ) {
        viewurl = '/query/web/api/v1/searchtrends/' + alias + '/';
    }

    return viewurl;

}
/**
 * Empty the contents rendered inside a parent elelment.
 * @param id {string} Parent element id.
 */
function emptySearchPagePart( id ) {
    if ( id ) {
        var content = $(' #' + id );
        if ( content ) {
            content.empty();
        }
    }
}

/**
 * Remove old and get new filters, aggregations and results part of the search page, and display them.
 */
function reloadFiltersAggregationsResults() {

    // Remove filters, aggregations and results content
    // Show loading icons
    // Get new filters, aggregations and search results and display them

    var filtersid = 'filters-content';

    emptySearchPagePart( filtersid );
    // Get current filters

    displayFiltersMenu( 1  );


    var aggregationsid = 'aggregations-content';
    emptySearchPagePart( aggregationsid );

    // Get aggregations

    displayAggregationsMenu( 1 );

    var resultsid = 'results-content';
    emptySearchPagePart( resultsid );

    // Get search results

    displayResultsMenu( 1 );
}

/**
 * Remove old and get new group menu.
 */
function reloadGroup() {
    var id = 'group-content';
    emptySearchPagePart( id );

    // Get group menu

    displayGroupMenu( 1 );
}

/**
 * Remove old and get new aggregations.
 */
function reloadAggregations() {
    var aggregationsid = 'aggregations-content';
    emptySearchPagePart( aggregationsid );

    // Get aggregations

    displayAggregationsMenu( 1 );
}

/**
 * Remove old and get new search results, then display them.
 */
function reloadResults() {

    // Remove search results content
    // Show loading icon
    // Get new search results and display them

    var resultsid = 'results-content';
    emptySearchPagePart( resultsid );

    // Get search results

    displayResultsMenu( 1 );
}

/**
 * Remove old and get new recent user searches, and display them.
 */
function reloadRecentSearches() {

    // Remove recent searches content
    // Show loading icon
    // Get new recent searches and display them

    var id = 'history-content';
    emptySearchPagePart( id );

    // Get new recent searches

    displayHistoryMenu( 1 );
}

/**
 * Remove old and get new trending searches for all users, and display them.
 */
function reloadTrendingSearches() {

    // Remove trending searches content
    // Show loading icon
    // Get new trending searches and display them

    var id = 'trends-content';
    emptySearchPagePart( id );

    // Get new trending searches

    displayTrendsMenu( 1 );
}

/**
 * Remove all search types and reload the search filters, aggregations and results.
 */
function clearSearchTypes() {

    // Check if there are any types
    var types = getTypeStringFromURL( Backbone.history.getFragment() );
    if ( types ) {

        // Remove all selected types

        var url;
        if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
            url = Backbone.history.location.pathname;
        } else {
            url = '/search/';
        }
        var query = App.globalState.query;
        var pagesize = App.globalState.pageSize;
        var group = App.globalState.group;
        var grid = App.globalState.grid;

        if ( query || ( pagesize && pagesize.toString() !== "20" ) || ( group && group !== "allgroup" ) || grid ) {
            url += '?';
        }

        if ( query ) {
            url += 'q=' + query;
        }

        // Keep page size selected, default pagesize is 20 and does not need a URL parameter
        if ( pagesize ) {
            if ( query ) {
                url += '&pagesize=' + pagesize;
            } else {
                url += 'pagesize=' + pagesize;
            }
        }


        // Group search. Default group is "all" and does not need a URL parameter.
        if ( group && group !== "allgroup" ) {
            if ( ( pagesize && pagesize.toString() !== "20" ) || query ) {
                url += '&group=' + group;
            } else {
                url += 'group=' + group;
            }
        }

        // Search results view
        if ( grid ) {
            if ( ( pagesize && pagesize.toString() !== "20" ) || query || ( group && group !== "allgroup" ) ) {
                url += '&view=grid';
            } else {
                url += 'view=grid';
            }
        }

        // Omit page number to reset page number to 1

        // Update the URL without triggering the route function
        router.navigate( url );

        // Set global type from the URL
        setTypeFromURL();

        // Set global filters from the URL
        setFiltersFromURL();

        // Reload filters, aggregations and results content
        reloadFiltersAggregationsResults();
    }
}

/**
 * Remove one of several search types and reload the search filters, aggregations and results.
 * @param target
 */
function removeSearchType( target ) {
    if ( target && $(target)) {
        var typevalue = $(target).parent();
        if ( typevalue && $(typevalue)) {
            var name = $(typevalue).attr("name");
            if ( name ) {
                // Remove selected type
                var types = getTypeStringFromURL( Backbone.history.getFragment() );
                if ( types ) {
                    var typesarray = types.split(',');
                    if ( typesarray ) {
                        var index = typesarray.indexOf( name );
                        if ( index > -1 ) {
                            // Modify types array by removing selected type
                            typesarray.splice( index, 1 );
                            // Join the elements into a new string
                            var modifiedtypes = typesarray.join(',');

                            var url;
                            if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
                                url = Backbone.history.location.pathname;
                            } else {
                                url = '/search/';
                            }

                            var query = App.globalState.query;
                            var pagesize = App.globalState.pageSize;
                            var group = App.globalState.group;
                            var type = App.globalState.searchType;
                            var grid = App.globalState.grid;

                            if ( query ) {
                                url += '?q=' + query;
                            }

                            if ( modifiedtypes && query ) {
                                url += '&type=' + modifiedtypes;
                            }

                            // Keep page size selected, default pagesize is 20 and does not need a URL parameter
                            if ( pagesize ) {
                                if ( query || type ) {
                                    url += '&pagesize=' + pagesize;
                                } else {
                                    url += 'pagesize=' + pagesize;
                                }
                            }

                            // Group search. Default group is "all" and does not need a URL parameter.
                            if ( group && group !== "allgroup" ) {
                                if ( ( pagesize && pagesize.toString() !== "20" ) || type || query ) {
                                    url += '&group=' + group;
                                } else {
                                    url += 'group=' + group;
                                }
                            }

                            // Search results view
                            if ( grid ) {
                                if ( ( group && group !== "allgroup" ) || ( pagesize && pagesize.toString() !== "20" ) || type || query ) {
                                    url += '&view=grid';
                                } else {
                                    url += 'view=grid';
                                }
                            }

                            // Omit page number to reset page number to 1

                            // Update the URL without triggering the route
                            router.navigate( url );

                            setTypeFromURL();

                            // Reload filters, aggregations and results
                            reloadFiltersAggregationsResults();

                        }
                    }
                }
            }
        }
    }
}

/**
 * Refine search filters based on facet checkboxes selected. Reload search filters, aggregations and search results.
 */
function refineSearchFilters() {

    // Get all text search aggregations

    var checkedtypes = [];
    var checkedfilters = [];

    var type = '';

    var aggregations = $('.search-aggregation');

    if ( aggregations ) {
        // Get facets for each aggregation
        for ( var i = 0; i < aggregations.length; i++ ) {

            var aggregation = aggregations[ i ];

            if ( aggregation && $( aggregation ) ) {

                var filter = {};
                filter.name = $(aggregation).attr( "name" );

                // Check if facets selected are data set types
                if ( filter.name === "edi_model_type" || filter.name === "__model_type" || filter.name === "__model_type.keyword" ) {

                    // Get all checked data types
                    // var types = $('.type-facet input[type="checkbox"]');
                    var types = $( aggregation ).find('.aggregation-facet');


                    if ( types ) {
                        for (var n = 0; n < types.length; n++) {

                            var datatype = types[ n ];

                            if ( datatype ) {

                                var inputbox = datatype.firstElementChild;

                                if ( inputbox && $(inputbox) && $(inputbox).is(":checked") ) {


                                    // Get the name of the type
                                    var displaynames = $(inputbox).next('.display-facet');

                                    if ( displaynames && displaynames.length > 0 ) {
                                        var displayname = displaynames[0];
                                        if ( displayname && $(displayname)) {
                                            var name = $(displayname).attr("key");
                                            if ( name ) {
                                                checkedtypes.push( name );
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if ( checkedtypes.length > 0 ) {

                        for ( var j = 0; j < checkedtypes.length; j++ ) {
                            type += checkedtypes[j];
                            if ( j < checkedtypes.length - 1 ) {
                                type += ',';
                            }
                        }
                    }

                } else {

                    var facets = $( aggregation ).find('.aggregation-facet');

                    if ( facets ) {
                        for ( var j = 0; j < facets.length; j++ ) {
                            var facet = facets[j];
                            if ( facet ) {
                                var checkbox = facet.firstElementChild;
                                if ( checkbox && $(checkbox) && $(checkbox).is(":checked")) {

                                    // Get the name of the facet
                                    var displaynames = $( checkbox ).next('.display-facet');


                                    if ( displaynames && displaynames.length > 0 ) {
                                        var displayname = displaynames[0];
                                        if ( displayname && $(displayname)) {
                                            var value = $(displayname).attr("key");
                                            var checkedfilter = {};

                                            checkedfilter.name = filter.name;
                                            checkedfilter.values = [];
                                            checkedfilter.values.push( value );
                                            checkedfilters.push( checkedfilter );
                                        }
                                    }

                                }
                            }
                        }
                    }
                }
            }
        }
    }

    console.log('checkedfilters: ', checkedfilters);                // testing =====
    console.log('checkedtypes: ', checkedtypes);                    // testing =====

    // Get all date aggregations

    var datefilters = getCurrentDateFilters();


    // Construct filters URL from text facets

    var filtersurl = '';
    for ( var k = 0; k < checkedfilters.length; k++ ) {
        var filterobj = checkedfilters[k];

        if ( filterobj  ) {

            var filtername = filterobj.name;
            var filtervalues = filterobj.values;

            if ( filtername && filtervalues ) {
                for ( var l = 0; l < filtervalues.length; l++ ) {

                    var filtervalue = filtervalues[ l ];
                    filtersurl += filtername + '|eq|' + filtervalue + ';';
                }
            }
        }
    }

    // Add date filters to the filters URL
    for ( var m = 0; m < datefilters.length; m++ ) {
        var dateobj = datefilters[ m ];

        if ( dateobj  ) {

            var datefiltername = dateobj.name;
            var datefiltervalue = dateobj.value;

            if ( datefiltername && datefiltervalue ) {
                filtersurl += datefiltername + '|btwn|' + datefiltervalue + ';';
            }
        }
    }


    var url;
    if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
        url = Backbone.history.location.pathname;
    } else {
        url = '/search/';
    }

    var query = App.globalState.query;
    var pagesize = App.globalState.pageSize;
    var group = App.globalState.group;
    var grid = App.globalState.grid;

    var urltypes = getTypeStringFromURL( Backbone.history.getFragment() );



    // Check if there are existing types or newly selected types before updating the page
    if ( query || urltypes || type || filtersurl || grid ) {
        url += '?';
    }

    if ( query ) {
        url += 'q=' + query;
    }

    if ( checkedtypes.length > 0 ) {

        if ( type && query ) {
            url += '&type=' + type;
        } else if ( type ) {
            url += 'type=' + type;
        }
    }

    if ( filtersurl && ( query || type ) ) {
        url += '&filters=' + filtersurl;
    } else if ( filtersurl ) {
        url += 'filters=' + filtersurl;
    }

    // Keep page size selected, default pagesize is 20 and does not need a URL parameter
    if ( pagesize ) {
        if ( query || type || filtersurl ) {
            url += '&pagesize=' + pagesize;
        } else {
            url += 'pagesize=' + pagesize;
        }
    }

    // Group search. Default group is "all" and does not need a URL parameter.
    if ( group && group !== "allgroup" ) {
        if ( ( pagesize && pagesize.toString() !== "20" ) || filtersurl || type || query ) {
            url += '&group=' + group;
        } else {
            url += 'group=' + group;
        }
    }

    // Search results view
    if ( grid ) {
        if ( ( group && group !== "allgroup" ) || ( pagesize && pagesize.toString() !== "20" ) || filtersurl || type || query ) {
            url += '&view=grid';
        } else {
            url += 'view=grid';
        }
    }

    // Omit page number to reset page number to 1

    // Update the URL without triggering the route function
    router.navigate( url );

    // Set global type from the URL
    setTypeFromURL();

    // Update global filters from the URL
    setFiltersFromURL();

    // Remove filters, aggregations and results content, show loading icons and reload the contents
    reloadFiltersAggregationsResults();

}

/**
 * Get current date filters if the date sliders have been moved from their min/max positions.
 * @returns {Array} Array of date filters to apply to search.
 */
function getCurrentDateFilters() {

    var datefilters = [];

    var dateaggregations = $('#aggregations-region .date-aggregation');

    var filtersUrl = getFiltersStringFromURL( Backbone.history.getFragment() );

    // Find date filters from the filters URL
    var filtersUrlArray;
    if ( filtersUrl ) {
        filtersUrlArray = filtersUrl.split(';');
    }

    if ( dateaggregations ) {

        // Get date slider for each date aggregation
        for ( var j = 0; j < dateaggregations.length; j++ ) {

            var dateaggregation = dateaggregations[ j ];

            if ( dateaggregation && $( dateaggregation ) ) {

                // Get the field name from .date-aggregation-name element (attribute "name")

                var datefield = $( dateaggregation ).find( '.date-aggregation-name' );

                if ( datefield ) {
                    var datefieldname = datefield.attr( 'name' );

                    if ( datefieldname ) {

                        // Get min and max attributes from the .date-range element
                        var daterange = $( dateaggregation ).find( '.slider-value' );

                        if ( daterange ) {

                            var min = daterange.attr('min');
                            var max = daterange.attr('max');

                            if ( min && max ) {

                                var histogram = $( dateaggregation ).find('.histogram');

                                if ( histogram ) {
                                    var slider = $( histogram ).find('.slider');

                                    if ( slider ) {
                                        var parameters = $( slider ).find('.parameter-value path');

                                        if ( parameters && parameters.length === 2 ) {
                                            var firstslider = parameters[ 0 ]; // left parameter (min)
                                            var secondslider = parameters[ 1 ]; // right parameter (max)

                                            var leftvalue;
                                            var rightvalue;
                                            if ( firstslider ) {
                                                leftvalue = $( firstslider ).attr('aria-valuenow');
                                            }
                                            if ( secondslider ) {
                                                rightvalue = $( secondslider ).attr('aria-valuenow');
                                            }

                                            if ( leftvalue ) {
                                                // Check if left value if of the format {minvalue},{maxvalue} which is the initial value
                                                // Take the {minvalue} to be the left value
                                                var leftvaluearray = leftvalue.split(',');
                                                if ( leftvaluearray ) {
                                                   leftvalue = leftvaluearray[ 0 ];
                                                }
                                            }

                                            if ( rightvalue ) {
                                                // Check if right value if of the format {minvalue},{maxvalue} which is the initial value
                                                // Take the {maxvalue} to be the right value
                                                var rightvaluearray = rightvalue.split(',');
                                                if ( rightvaluearray ) {
                                                    if ( rightvaluearray.length === 1 ) {
                                                        rightvalue = rightvaluearray[ 0 ];
                                                    } else if ( rightvaluearray.length === 2 ) {
                                                        rightvalue = rightvaluearray[ 1 ];
                                                    }
                                                }
                                            }


                                            var newvalue = leftvalue + ',' + rightvalue;

                                            // Compare each parameter with min and max
                                            // Compare each parameter to existing global date filters

                                            // Check global filters array for date field name
                                            var globaFilterFound = false;
                                            var globalFilterValue;
                                            if ( filtersUrlArray ) {
                                                for ( var k = 0; k < filtersUrlArray.length; k++ ) {
                                                    var globalFilter = filtersUrlArray[ k ];
                                                    if ( globalFilter ) {
                                                        var globalFilterArray = globalFilter.split('|');
                                                        if ( globalFilterArray && globalFilterArray.length === 3 ) {
                                                            var globalFilterName = globalFilterArray[ 0 ];
                                                            if ( globalFilterName === datefieldname ) {
                                                                globaFilterFound = true;
                                                                globalFilterValue = globalFilterArray[ 2 ];
                                                            }
                                                        }
                                                    }
                                                }
                                            }


                                            // TODO
                                            // Add the new date from January of the lowest year to December of the highest year

                                            // If nothing changed and there is no global filter, don't add the date filter to the request

                                            // If left or/and right value moved and nothing is in the global date filters, add the new between filter to the request
                                            if ( ! globaFilterFound && ( leftvalue !== min || rightvalue !== max )) {
                                                var datefilterobj = {};
                                                datefilterobj.name = datefieldname;
                                                datefilterobj.value = newvalue;
                                                datefilters.push( datefilterobj );
                                            }
                                            // If global filter existed for the same date field, and nothing changed, add the same filter to the request
                                            // If global filter existed for the same date field and left or/and right values changed, add updated filter to the request
                                            else if ( globaFilterFound && newvalue ) {
                                                var datefilterobj = {};
                                                datefilterobj.name = datefieldname;
                                                datefilterobj.value = newvalue;
                                                datefilters.push( datefilterobj );
                                            }

                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    return datefilters;
}

/**
 * Remove all search filters, including types, and reload the search filters, aggregations and results.
 */
function clearSearchFilters() {

    // Remove all selected filters and types

    var url;
    if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
        url = Backbone.history.location.pathname;
    } else {
        url = '/search/';
    }

    var query = App.globalState.query;
    var type = App.globalState.searchType;
    var pagesize = App.globalState.pageSize;
    var group = App.globalState.group;
    var grid = App.globalState.grid;

    if ( query ) {
        url += '?q=' + query;
    }

    // Keep page size selected, default pagesize is 20 and does not need a URL parameter
    if ( pagesize ) {
        if ( query || type ) {
            url += '&pagesize=' + pagesize;
        } else {
            url += 'pagesize=' + pagesize;
        }
    }

    // Group search. Default group is "all" and does not need a URL parameter.
    if ( group && group !== "allgroup" ) {
        if ( ( pagesize && pagesize.toString() !== "20" ) || type || query ) {
            url += '&group=' + group;
        } else {
            url += 'group=' + group;
        }
    }

    // Search results view
    if ( grid ) {
        if ( ( group && group !== "allgroup" ) || ( pagesize && pagesize.toString() !== "20" ) || type || query ) {
            url += '&view=grid';
        } else {
            url += 'view=grid';
        }
    }


    // Omit page number to reset page number to 1

    // Update the URL without triggering the route function
    router.navigate( url );

    // Set global type from the URL
    setTypeFromURL();

    // Update global filters from the URL
    setFiltersFromURL();

    // Set page from URL
    setPageFromURL();

    // Remove filters, aggregations and results content, show loading icons and reload the contents
    reloadFiltersAggregationsResults();

}

/**
 * Select one single type and reload the search filters, aggregations and results.
 * @param target {object} Data type name.
 */
function selectDataType( target ) {


    if ( target && $( target ) ) {

        var type = $( target ).attr("name") || $( target ).attr("key");
        if ( type ) {

            var url;
            if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
                url = Backbone.history.location.pathname;
            } else {
                url = '/search/';
            }

            var query = App.globalState.query;
            var pagesize = App.globalState.pageSize;
            var group = App.globalState.group;
            var grid = App.globalState.grid;

            if ( query || type || grid || ( pagesize && pagesize.toString() !== "20" ) || ( group && group !== "allgroup" ) ) {
                url += '?';
            }

            if ( query ) {
                url += 'q=' + query;
            }

            if ( type && query ) {
                url += '&type=' + type;
            } else if ( type ) {
                url += 'type=' + type;
            }

            // Keep page size selected, default pagesize is 20 and does not need a URL parameter
            if ( pagesize ) {
                if ( query || type ) {
                    url += '&pagesize=' + pagesize;
                } else {
                    url += 'pagesize=' + pagesize;
                }
            }

            // Group search. Default group is "all" and does not need a URL parameter.
            if ( group && group !== "allgroup" ) {
                if ( ( pagesize && pagesize.toString() !== "20" ) || type || query ) {
                    url += '&group=' + group;
                } else {
                    url += 'group=' + group;
                }
            }

            // Search results view
            if ( grid ) {
                if ( ( group && group !== "allgroup" ) || ( pagesize && pagesize.toString() !== "20" ) || type || query ) {
                    url += '&view=grid';
                } else {
                    url += 'view=grid';
                }
            }

            // Omit the page number to load page 1

            // Update the URL without triggering the route
            router.navigate( url );

            setTypeFromURL();

            // Set page from URL
            setPageFromURL();

            // Reload filters, aggregations and results
            reloadFiltersAggregationsResults();
        }
    }
}

/**
 * Add a single type facet to the current filters if it isn't selected yet and reload the search filters, aggregations and results.
 * @param target {object} Type facet name.
 */
function selectTypeFacet( target ) {


    if ( target && $( target ) ) {

        var type = App.globalState.searchType;

        var searchfilters = App.globalState.searchFilters;

        var parent = $( target ).parents('.search-aggregation');

        var facetname;
        if ( parent && $(parent) ) {
            facetname = $(parent).attr("name");
        }

        var facetvalue = $( target ).attr("key");

        if ( facetname && facetvalue ) {

            // Determine if display facet is a type facet

            if ( facetname === "edi_model_type" || facetname === "__model_type" || facetname === "__model_type.keyword" ) {
                selectDataType( target );
            } else {

                var isnewfacet = true; // Default flag value

                var filtersurl = '';

                // Check if selected facet already exists in the search filters
                if ( searchfilters ) {

                    var searchfiltersarray = searchfilters.split(';');
                    if ( searchfiltersarray ) {
                        for ( var i = 0; i < searchfiltersarray.length; i++ ) {
                            var searchfilter = searchfiltersarray[ i ];
                            if ( searchfilter ) {
                                var searchfilterarray = searchfilter.split('|');
                                if ( searchfilterarray && searchfilterarray.length === 3 ) {
                                    var searchfiltername = searchfilterarray[ 0 ];
                                    var searchfiltervalue = searchfilterarray[ 2 ];

                                    if ( searchfiltername === facetname && searchfiltervalue === facetvalue ) {
                                        // Facet already exists in the search filters - do not add it again
                                        isnewfacet = false;
                                    }
                                }
                            }
                        }
                    }

                    // If search filters exist and the facet is new, add the facet to the filters URL
                    if ( isnewfacet ) {

                        var encoded_facetvalue = encodeURIComponent( facetvalue );                          // ===== testing
                        filtersurl = searchfilters + facetname + '|eq|' + encoded_facetvalue + ';';           // ===== testing

                        // filtersurl = searchfilters + facetname + '|eq|' + facetvalue + ';';
                    }

                } else {
                    // Add selected facet to the filters URL

                    var encoded_facetvalue = encodeURIComponent( facetvalue );              // ===== testing
                    filtersurl = facetname + '|eq|' + encoded_facetvalue + ';';           // ===== testing

                    // filtersurl = facetname + '|eq|' + facetvalue + ';';
                }

                // Update URL if selected facet is new
                if ( isnewfacet ) {

                    var url;
                    if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
                        url = Backbone.history.location.pathname;
                    } else {
                        url = '/search/';
                    }

                    var query = App.globalState.query;
                    var pagesize = App.globalState.pageSize;
                    var group = App.globalState.group;
                    var grid = App.globalState.grid;

                    if ( query || type || pagesize || grid || ( group && group !== "allgroup" ) || ( pagesize && pagesize.toString() !== "20" )) {
                        url += '?';
                    }

                    if ( query ) {
                        url += 'q=' + query;
                    }

                    if ( type && query ) {
                        url += '&type=' + type;
                    } else if ( type ) {
                        url += 'type=' + type;
                    }

                    if ( filtersurl && ( type || query ) ) {
                        url += '&filters=' + filtersurl;
                    } else if ( filtersurl ) {
                        url += 'filters=' + filtersurl;
                    }

                    // Keep page size selected, default pagesize is 20 and does not need a URL parameter
                    if ( pagesize ) {
                        if ( query || type || filtersurl ) {
                            url += '&pagesize=' + pagesize;
                        } else {
                            url += 'pagesize=' + pagesize;
                        }
                    }

                    // Group search. Default group is "all" and does not need a URL parameter.
                    if ( group && group !== "allgroup" ) {
                        if ( ( pagesize && pagesize.toString() !== "20" ) || filtersurl || type || query ) {
                            url += '&group=' + group;
                        } else {
                            url += 'group=' + group;
                        }
                    }

                    // Search results view
                    if ( grid ) {
                        if ( ( group && group !== "allgroup" ) || ( pagesize && pagesize.toString() !== "20" ) || filtersurl || type || query ) {
                            url += '&view=grid';
                        } else {
                            url += 'view=grid';
                        }
                    }


                    // Omit page number to default page 1

                    // Update URL without triggering the route function
                    router.navigate( url );

                    // Set page from URL
                    setPageFromURL();

                    // Update global filters
                    setFiltersFromURL();

                    // Reload filters, aggregations and search results
                    reloadFiltersAggregationsResults();
                }
            }
        }
    }
}

/**
 * Remove a single search facet from the current filters and reload the search filters, aggregations and results.
 * @param target {object} Type facet name.
 */
function removeTypeFacet( target ) {


    if ( target && $( target ) ) {

        var searchfilters = App.globalState.searchFilters;

        var parent = $( target ).parents('.facet-filter');

        var facetname;
        var facetvalue;
        if ( parent && $( parent ) ) {
            facetname = $( parent ).attr("name");
            facetvalue = $( parent ).attr("value");
        }

        if ( facetname && facetvalue ) {

            var newsearchfilters = '';

            // Check if selected facet already exists in the search filters
            if ( searchfilters ) {

                var searchfiltersarray = searchfilters.split( ';' );
                if ( searchfiltersarray ) {
                    for ( var i = 0; i < searchfiltersarray.length; i++ ) {
                        var searchfilter = searchfiltersarray[ i ];
                        if ( searchfilter ) {
                            var searchfilterarray = searchfilter.split('|');
                            if ( searchfilterarray && searchfilterarray.length === 3 ) {
                                var searchfiltername = searchfilterarray[ 0 ];
                                var searchfiltervalue = searchfilterarray[ 2 ];

                                if ( ! ( searchfiltername === facetname && searchfiltervalue === facetvalue ) ) {
                                    // Add the filter to the new filters URL
                                    newsearchfilters += searchfilter + ';';
                                }
                            }
                        }
                    }
                }
            }

            // Update URL with new filters URL

            var url;
            if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
                url = Backbone.history.location.pathname;
            } else {
                url = '/search/';
            }

            var query = App.globalState.query;
            var type = App.globalState.searchType;
            var pagesize = App.globalState.pageSize;
            var group = App.globalState.group;
            var grid = App.globalState.grid;

            if ( query || type || newsearchfilters || ( pagesize && pagesize.toString() !== "20" ) || ( group && group !== "allgroup" ) || grid ) {
                url += '?';
            }

            if ( query ) {
                url += 'q=' + query;
            }

            if ( type && query ) {
                url += '&type=' + type;
            } else if ( type ) {
                url += 'type=' + type;
            }

            if ( newsearchfilters && ( type || query ) ) {
                url += '&filters=' + newsearchfilters;
            } else if ( newsearchfilters ) {
                url += 'filters=' + newsearchfilters;
            }

            // Keep page size selected, default pagesize is 20 and does not need a URL parameter
            if ( pagesize) {
                if ( query || type || newsearchfilters ) {
                    url += '&pagesize=' + pagesize;
                } else {
                    url += 'pagesize=' + pagesize;
                }
            }

            // Group search. Default group is "all" and does not need a URL parameter.
            if ( group && group !== "allgroup" ) {
                if ( ( pagesize && pagesize.toString() !== "20" ) || type || query ) {
                    url += '&group=' + group;
                } else {
                    url += 'group=' + group;
                }
            }

            // Search results view
            if ( grid ) {
                if ( ( pagesize && pagesize.toString() !== "20" ) || type || query || ( group && group !== "allgroup" ) ) {
                    url += '&view=grid';
                } else {
                    url += 'view=grid';
                }
            }


            // Omit the page number to default to page 1

            // Update the URL without triggering the route function
            router.navigate( url );

            // Set page from URL
            setPageFromURL();

            // Update global filters from the URL
            setFiltersFromURL();

            // Remove filters, aggregations and results content, show loading icons and reload the contents
            reloadFiltersAggregationsResults();
        }
    }
}

/**
 * Show selected search page of results.
 * @param target {object} Search page number in the pagination element.
 */
function showSearchPage( target ) {

    if ( target && $( target ) ) {
        var span = $( target ).find('span');
        if ( span && $(span) ) {

            // If current page is clicked on, don't do anything
            if ( ! $(span).hasClass("current-page") ) {

                var pagetext = $(span).text();


                if ( pagetext ) {

                    var page;

                    if ( pagetext.toLowerCase() === "next" ) {

                        // Go to the next page
                        page = Number( App.globalState.searchPage ) + 1 ;
                    }
                    else if ( pagetext.toLowerCase() === "previous" ) {

                        // Go to the previous page
                        page = Number( App.globalState.searchPage ) - 1;
                    } else {

                        var pagenumber = Number( pagetext );
                        if (Number.isInteger(pagenumber) && pagenumber > 0) {

                            // Go to the page specified
                            page = pagenumber;
                        }
                    }

                    // Update URL with new filters URL

                    if ( page && page > 0 ) {

                        var url;
                        if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
                            url = Backbone.history.location.pathname;
                        } else {
                            url = '/search/';
                        }

                        var query = App.globalState.query;
                        var type = App.globalState.searchType;
                        var filters = App.globalState.searchFilters;
                        var pagesize = App.globalState.pageSize;
                        var group = App.globalState.group;
                        var grid = App.globalState.grid;

                        if ( query || page || type || filters || grid || ( pagesize && pagesize.toString() !== "20" ) || ( page && page > 1 ) || ( group && group !== "allgroup" ) ) {
                            url += '?';
                        }

                        if ( query ) {
                            url += 'q=' + query;
                        }

                        if ( type && query ) {
                            url += '&type=' + type;
                        } else if ( type ) {
                            url += 'type=' + type;
                        }

                        if ( filters && ( type || query ) ) {
                            url += '&filters=' + filters;
                        } else if ( filters ) {
                            url += 'filters=' + filters;
                        }

                        // Default page size is 20
                        if ( pagesize ) {
                            if ( filters || type || query ) {
                                url += '&pagesize=' + pagesize;
                            } else  {
                                url += 'pagesize=' + pagesize;
                            }
                        }

                        // Default page is 1 that doesn't need to be set explicitly in the URL
                        // If omitted, page 1 will be returned
                        if ( page && page > 1 ) {
                            if ( type || query || filters ) {
                                url += '&page=' + page;
                            } else {
                                url += 'page=' + page;
                            }
                        }

                        // Group search. Default group is "all" and does not need a URL parameter.
                        if ( group && group !== "allgroup" ) {
                            if ( ( pagesize && pagesize.toString() !== "20" ) || filters || type || query ) {
                                url += '&group=' + group;
                            } else {
                                url += 'group=' + group;
                            }
                        }

                        // Tile view
                        if ( grid ) {
                            if ( ( pagesize && pagesize.toString() !== "20" ) || filters || type || query || ( group && group !== "allgroup" )) {
                                url += '&view=grid';
                            } else {
                                url += 'view=grid';
                            }
                        }

                        // Update the URL without triggering the route function
                        router.navigate( url );

                        // Set page from URL
                        setPageFromURL();

                        // Reload search results
                        reloadResults();
                    }
                }
            }
        }
    }
}

/**
 * Show selected number of search results per page.
 * @param target {object} Search page number in the pagination element.
 */
function showResultsPerPage( target ) {

    if ( target && $( target ) ) {

        var option = $(target).find("option:selected").attr('value');
        if ( option ) {

            var pagesize = App.globalState.pageSize;

            if ( option !== pagesize ) {

                // Update URL with new pagesize

                var url;
                if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
                    url = Backbone.history.location.pathname;
                } else {
                    url = '/search/';
                }

                var query = App.globalState.query;
                var type = App.globalState.searchType;
                var filters = App.globalState.searchFilters;
                var group = App.globalState.group;
                var grid = App.globalState.grid;

                if ( query || type || filters || grid || ( option && option.toString() !== "20" ) || ( group && group !== "allgroup" )) {
                    url += '?';
                }

                if ( query ) {
                    url += 'q=' + query;
                }

                if ( type && query ) {
                    url += '&type=' + type;
                } else if ( type ) {
                    url += 'type=' + type;
                }

                if ( filters && ( type || query ) ) {
                    url += '&filters=' + filters;
                } else if ( filters ) {
                    url += 'filters=' + filters;
                }

                // Keep page size selected, default pagesize is 20 and does not need a URL parameter
                if ( option && option.toString() !== "20" ) {
                    if ( query || type ) {
                        url += '&pagesize=' + option;
                    } else {
                        url += 'pagesize=' + option;
                    }
                }

                // Search group. Default group is "all" and does not need a URL parameter.
                if ( group && group !== "allgroup" ) {
                    if ( ( option && option.toString() !== "20" ) || query || type ) {
                        url += '&group=' + group;
                    } else {
                        url += 'group=' + group;
                    }
                }

                // Search results view
                if ( grid ) {
                    if ( ( group && group !== "allgroup" ) || query || type || filters || ( option && option.toString() !== "20" ) ) {
                        url += '&view=grid';
                    } else {
                        url += 'view=grid';
                    }
                }

                // Omit setting search page because page 1 will be returned by default

                // Update the URL without triggering the route function
                router.navigate( url );

                // Set pagesize from URL
                setPageSizeFromURL();

                // Set page from URL
                setPageFromURL();

                // Reload search results
                reloadResults();
            }
        }
    }
}

/**
 * Set selected search results view in the URL.
 */
function setSearchResultsView( ) {

    if ( Backbone && Backbone.history ) {
        var current = Backbone.history.getFragment();

        if ( current ) {

            var view = getViewTypeFromURL( current );
            var isGrid = App.globalState.grid;


            var url = current;
            var hasParams = false;

            if ( current.indexOf('?') > -1 ) {
                hasParams = true;
            }

            // Grid view is selected; no view type is specified in the URL
            if ( isGrid && ! view ) {
                if ( hasParams ) {
                    url += '&';
                } else {
                    url += '?';
                }
                url += 'view=grid';
            }

            // List view is selected. Remove view type from the URL.
            if ( ! isGrid && view === "grid" ) {

                var stringToRemove;
                if ( current.indexOf('?view=grid') > -1 ) {
                    stringToRemove = '?view=grid';
                } else if ( current.indexOf('&view=grid') > -1 ) {
                    stringToRemove = '&view=grid';
                }
                url = current.replace( stringToRemove, "" );
            }

            // Update the URL without triggering the route function
            if ( router ) {
                router.navigate( url );
            }
        }
    }
}

/**
 * Show selected search group and perform the search.
 * @param target {object} Search group menu item.
 */
function showSearchGroup( target ) {

    if ( target && $( target) ) {

        // Check if target is already selected

        var classnames = $( target ).attr("class");

        if ( classnames && classnames.indexOf('active') === -1 ) {
            var groupname = $( target ).attr("id");
            if ( groupname ) {

                // Save new group to global state
                App.globalState.group = groupname;
                // If target has not been previously selected, construct a new URL and reload search group, aggregations and results

                // Update URL with new group

                var url;
                if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
                    url = Backbone.history.location.pathname;
                } else {
                    url = '/search/';
                }

                var query = App.globalState.query;
                var type = App.globalState.searchType;
                var filters = App.globalState.searchFilters;
                var pagesize = App.globalState.pageSize;
                var grid = App.globalState.grid;

                if ( query || pagesize || type || filters || grid || ( pagesize && pagesize.toString() !== "20" ) || ( groupname && groupname !== "allgroup" ) ) {
                    url += '?';
                }

                if ( query ) {
                    url += 'q=' + query;
                }

                if ( type && query ) {
                    url += '&type=' + type;
                } else if ( type ) {
                    url += 'type=' + type;
                }

                if ( filters && ( type || query ) ) {
                    url += '&filters=' + filters;
                } else if ( filters ) {
                    url += 'filters=' + filters;
                }

                // Keep page size selected, default pagesize is 20 and does not need a URL parameter
                if ( pagesize ) {
                    if ( query || type || filters ) {
                        url += '&pagesize=' + pagesize;
                    } else {
                        url += 'pagesize=' + pagesize;
                    }
                }

                // Add group URL parameter if it isn't "all". "All" is the default group and doesn't need a URL parameter.
                if ( groupname && groupname !== "allgroup" ) {
                    if ( ( pagesize && pagesize.toString() !== "20" ) || query || type || filters )  {
                        url += '&group=' + groupname;
                    } else {
                        url += 'group=' + groupname;
                    }
                }

                // Search results view
                if ( grid ) {
                    if ( ( groupname && groupname !== "allgroup" ) || ( pagesize && pagesize.toString() !== "20" ) || query || type || filters ) {
                        url += '&view=grid';
                    } else {
                        url += 'view=grid';
                    }
                }

                // Omit setting search page because page 1 will be returned by default


                // Update the URL without triggering the route function
                router.navigate( url );

                // Set group from URL
                setGroupFromURL();

                // Set page from URL
                setPageFromURL();

                // Reload group, aggregations and search results
                reloadGroup();

                reloadAggregations();

                reloadResults();

            }
        }
    }
}

/**
 * Navigate to the selected site in the same environment as the current environment (dev, stage or production).
 * @param target
 */
function selectSiteOption( target ) {

    // Find the current environment, protocol and pathname of the current page

    var isdev = false;
    var isstage = false;
    var isprod = false;
    var pathname;
    var protocol;

    if ( Backbone && Backbone.history ) {
        var location = Backbone.history.location;
        if (location) {
            var host = location.host;
            if ( host ) {
                // Check if current URL is dev, stage or production
                if ( host.indexOf("-dev") > -1 ) {
                    isdev = true;
                } else if ( host.indexOf("-stage") > -1 ) {
                    isstage = true;
                } else {
                    isprod = true;
                }
            }
            // Get the current page URL i.e. /search/ or /search
            pathname = location.pathname;

            // Get the current protocol i.e. HTTP or HTTPS
            protocol = location.protocol;
        }
    }

    if ( target && $( target ) ) {

        var option = $( target ).find("option:selected");

        if ( option ) {
            var origins = option.attr("origin");

            if ( origins ) {
                var originarray = origins.split(';');

                // Check origin array and find the same environment
                if ( originarray ) {
                    for ( var i = 0; i < originarray.length; i++ ) {

                        var origin = originarray[ i ];

                        if ( origin ) {
                            var url = '';

                            if ( ( origin.indexOf("-dev") > -1 && isdev ) || ( origin.indexOf("-stage") > -1 && isstage ) ||  isprod ) {
                                // Construct a URL to dev, stage or production site
                                if ( protocol ) {
                                    url += protocol + '//';
                                }
                                url += origin;
                                if ( pathname ) {
                                    url += pathname;
                                }
                                // Navigate to the selected site
                                if ( window && window.location ) {
                                    window.location.href = url;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Save search option selected from search options dropdown to the global state.
 * @param target {object} Search options select element.
 */
function selectSearchOption( target ) {

    if ( target && $( target ) ) {
        var option = $( target ).find("option:selected").attr('value');
        if ( option ) {
            if ( option === "exact") {
                // Default search option (exact) does not need a value
                App.globalState.searchOption = null;
                App.globalState.fuzzyDegree = null;
            } else {
                if ( option.startsWith("fuzzy")) {

                    // Get the fuzziness degree
                    var optionarray = option.split('-');
                    if ( optionarray && optionarray.length === 2 && optionarray[ 0 ] && optionarray[ 1 ]) {
                        App.globalState.searchOption = optionarray[ 0 ].toString();
                        App.globalState.fuzzyDegree = optionarray[ 1 ].toString();
                    } else {
                        App.globalState.searchOption = "fuzzy";
                        App.globalState.fuzzyDegree = null;
                    }

                } else {
                    App.globalState.searchOption = option;
                    App.globalState.fuzzyDegree = null;
                }
            }
        }
    }
}

/**
 * Select the search option based on global state.
 */
function setSearchOption( ) {

    var option;

    var optionvalue = App.globalState.searchOption;

    if ( optionvalue === "fuzzy" && App.globalState.fuzzyDegree && typeof App.globalState.fuzzyDegree === "string" ) {
        optionvalue += '-' + App.globalState.fuzzyDegree;
    }

    option = $('#search .search-options select option[value="' + optionvalue + '"]');

    if ( option ) {
        option.prop('selected', 'selected');
    }
}

/**
 * Select the search results per page option based on global state.
 */
function setResultsPerPage( ) {

    var optionvalue = App.globalState.pageSize;

    var option = $('.search-results-pagination select option[value="' + optionvalue + '"]');

    if ( option ) {
        option.prop('selected', 'selected');
    }
}

/**
 * Set the search group display based on global state.
 */
function setSearchGroup() {

    var group = App.globalState.group;

    if ( group ) {
        // Get all group links in the group region
        var items = $('.content-tabs .group-item');
        if ( items ) {
            for ( var i = 0; i < items.length; i++ ) {
                var item = items[i];
                if ( item ) {
                    if ( $(item) && $(item).attr('id') === group ) {
                        // Currently selected group
                        $(item).addClass('active');
                    } else {
                        // Remove active class from groups that are not selected
                        $(item).removeClass('active');
                    }
                }
            }
        }
    }
}

/***
 * Fetch records when input in the search box changes.
 */
var fetchRecords = _.debounce(function ( ) {
    var base = window.location.pathname,
        query = $('input[name="basic-search"]').val(),
        path,
        searchApp;
    
    // Checks for at least 2 " to then substitute out for || so it can be passed through filters for exact searching
    if ( query.split( '"' ).length - 1 >= 2 ) {             // ===== testing
        query = query.replaceAll( '"', '|||' );
    };

    // Check if current page is the search page
    if ( query && base && base.startsWith("/search") ) {

        // Check that the search option selected is "EDI"
        if ( typeof sharedStylesGlobals !== "undefined" ) {
            searchApp = sharedStylesGlobals.searchApp;
        }

        // If search app is "edi" or search app is undefined, do search
        if ( searchApp === "edi" || typeof searchApp === "undefined" ) {


            // Show search suggestions
            autocomplete( query );

            // Clean input query
            query = cleanInput( query );
            App.globalState.query = query;

            // Update the URL based on the search box input
            if ( window && window.location ) {
                path = window.location.pathname;
                if ( path && path.length > 0 ) {


                    // Set the page to 1
                    var page = 1;
                    App.globalState.searchPage = page;

                    // Update URL with parameters: existing types, filters and pagesize

                    var url;
                    if ( Backbone && Backbone.history && Backbone.history.location && Backbone.history.location.pathname ) {
                        url = Backbone.history.location.pathname;
                    } else {
                        url = '/search/';
                    }

                    var type = App.globalState.searchType;
                    var filters = App.globalState.searchFilters;
                    var pagesize = App.globalState.pageSize;
                    var group = App.globalState.group;
                    var searchoption = App.globalState.searchOption;
                    var fuzzydegree = App.globalState.fuzzyDegree;

                    if ( query || page || type || filters ) {
                        url += '?';
                    }

                    if ( query ) {
                        url += 'q=' + query;
                    }

                    if ( type && query ) {
                        url += '&type=' + type;
                    } else if ( type ) {
                        url += 'type=' + type;
                    }

                    if ( filters && ( type || query ) ) {
                        url += '&filters=' + filters;
                    } else if ( filters ) {
                        url += 'filters=' + filters;
                    }

                    // Default pagesize is 20 and does not need to be added to the URL
                    if ( pagesize ) {
                        if ( filters || type || query ) {
                            url += '&pagesize=' + pagesize;
                        } else {
                            url += 'pagesize=' + pagesize;
                        }
                    }

                    // Group search. Default group is "all" and does not need a URL parameter.
                    if ( group && group !== "allgroup" ) {
                        if ( ( pagesize && pagesize.toString() !== "20" ) || filters || type || query ) {
                            url += '&group=' + group;
                        } else {
                            url += 'group=' + group;
                        }
                    }

                    // Check if URL is the same as the current URL
                    var currenturl = '/' + Backbone.history.getFragment();


                    // When the current URL and the new URL are the same, the Backbone router won't trigger a redirect
                    // See https://github.com/jashkenas/backbone/issues/1214 for details
                    // Use case: selecting a search option (fuzzy, exact, etc.) and clicking search button
                    // won't change the URL and won't re-trigger page reload
                    // In this case, reload the search UI directly
                    if ( currenturl === url ) {

                        // Reload filters, aggregations and results
                        reloadFiltersAggregationsResults();

                        // Reload recent searches
                        reloadRecentSearches();

                        // Reload trending searches
                        reloadTrendingSearches();


                    } else {
                        router.navigate( url, { trigger: true } );
                    }
                }
            }
        }
    } else {

        if ( ! query ) {

            App.globalState.query = "";
            $('input[name="basic-search"]').val("");
        } else {
            // Update the query
            query = cleanInput( query );
            App.globalState.query = query;
        }

        // Redirect to search page
        var searchUrl = "/search/?q=" + App.globalState.query;

        router.navigate( searchUrl, { trigger: true } );

    }
}, 250);

/**
 * jQuery listener that triggers search on search button click.
 */
function basicSearch() {

    var searchButtonId = App.globalState.searchButtonId;

    // Listen for search button click event
    $('#' + searchButtonId).on( 'click', function( e ) {
        fetchRecords( );
    } );

    // Listen for search bar enter key event
    $('input[name="basic-search"]').on('keypress', function ( e ) {
        if ( e.keyCode === 13 ) {
            fetchRecords( );
        }
    });
}

/***
 * Remove special characters from the user query
 * @param query {string} - search query
 */
function modifyQuery(query) {
    var cleanQuery = decodeURIComponent(query);
    //Remove () and [] - NTC 2/7/2022
    return cleanQuery.replace(/!$%@<>{}/g, "");
}

/**
 * Sanitize HTML from string.  Leaves only br and p tags, with no attributes.
 * Uses the Sanitize.js package, installable by bower or npm.
 * @param value {string} - input HTML string
 * @returns {string}
 */
function sanitizeText( value ) {
    var sanitizer,
        div,
        frag;

    div = document.createElement('div');

    if ( ! ( value === null || value === undefined ) ) {
        sanitizer = new Sanitize({elements: ['br', 'p']});

        div.innerHTML = value.toString();
        frag = sanitizer.clean_node(div);
        div.innerHTML = "";
        $(div).append(frag);

    }
    return div.innerHTML;
}

// /**
//  * Sanitize HTML from string.  Leaves no tags and no attributes.
//  * Uses the Sanitize.js package, installable by bower or npm.
//  * @param value {string} - input HTML string
//  * @returns {string}
//  */
// function sanitizeAll_old( value ) {
//     var sanitizer,
//         div,
//         frag;
//     sanitizer = new Sanitize();
//     div = document.createElement('div');
//     div.innerHTML = value;
//     frag = sanitizer.clean_node(div);
//     div.innerHTML = "";
//     $(div).append(frag);
//     return div.innerHTML;
// }

/**
 * Sanitize HTML from string.  Leaves no tags and no attributes.
 * Uses the Sanitize.js package, installable by bower or npm.
 * @param value {string} - input HTML string
 * @returns {string}
 */
function sanitizeAll( value ) {
    var sanitizer,
        div,
        frag;
    sanitizer = new Sanitize();
    div = document.createElement('div');
    var parser = new DOMParser();
    var doc = parser.parseFromString(value, "text/html");
    var body = doc.getElementsByTagName('body')[0];
    frag = sanitizer.clean_node(body);
    $(div).append(frag);
    return div.textContent;
};

/**
 * Hide search loading icon
 * @param iconId {string} - ID attribute of the spinner icon
 */
function hideSearchLoadingIcon( iconId ) {
    // Hide loading icon
    if ( iconId ) {
        if ( iconId.substr( 0, 1 ) !== "#" ) {
            iconId = '#' + iconId;
        }
        $( iconId ).hide();
    }
}